if (window) {
  if (window.jsq_detected) {
    throw "Browser extensions detected";
  } else {
    window.jsq_detected = true;
  }
}

require.config({
  waitSeconds: 10,
  paths: {
    jQuery: "jquery",
    bootstrap: "bootstrap.min",
    history: "jquery.history",
    select2: "select2-3.4.8.min",
    typeahead: "typeahead",
    modernizr: "modernizr.min",
    datepicker: "bootstrap-datepicker",
    jsqObservability: "jsq-observability.min",
    zxcvbn: "zxcvbn",
    objectAssign: "object-assign",
    google_charts: "requirejs_plugins/google_charts",
    markerclusterer: "markerclusterer",
    inputmask: "../static/inputmask/inputmask.min",
    "inputmask.numeric.extensions":
      "../static/inputmask/inputmask.numeric.extensions.min",
    "dependencyLibs/inputmask.dependencyLib":
      "../static/inputmask/dependencyLibs/inputmask.dependencyLib.jquery.min",
    "global/window": "../static/inputmask/global/window.min",
    "global/document": "../static/inputmask/global/document.min"
  },
  // the capitalization difference here seems to confuse requirejs
  // make sure that any requests for "jquery" are redirected to "jQuery" module we defined above
  map: {
    "*": {
      jquery: "jQuery",
    },
  },
  shim: {
    jQuery: {
      exports: "$"
    },
    bootstrap: {
      deps: ["jQuery"]
    },
    history: {
      deps: ["jQuery"]
    },
    select2: {
      deps: ["jQuery"]
    },
    typeahead: {
      deps: ["jQuery"],
      exports: "Bloodhound"
    },
    modernizr: {},
    datepicker: {
      deps: ["jQuery"]
    },
    markerclusterer: {
      exports: "MarkerClusterer"
    },
  }
});
define("config", function(){});

